import React from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";

import { formConstants } from "../../../helpers/vorgange";
import { QES_SIGNING_START } from "../../../constants/SigningProviderConstants";
import MDCButton from "../../core/MDCButton";
import MDCLabel from "../../core/MDCLabel";
import MDCText from "../../core/MDCText";
import MDCLoader from "../../core/MDCLoader";
import ErrorText from "../../shared/ErrorText";

const useStyles = makeStyles((theme) => ({
  container: {
    color: theme.palette.MDCColors.textColor,
  },
  setupForm: {
    maxWidth: "48rem",
    margin: "0 auto",
    position: "relative",
  },
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    backgroundColor: "rgba(255, 255, 255, 0.8)",
  },
  fieldRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "1rem",
  },
  readonlyValue: {
    minHeight: "2.625rem",
    minWidth: 0,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    padding: "0 .938rem",
    marginTop: ".625rem",
    borderRadius: "5px",
    background: theme.palette.MDCColors.cardBackgroundColor,
    color: theme.palette.MDCColors.textColor,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: ".5rem",
    marginTop: "2rem",
  },
  signersCard: {
    border: "1px solid #d9d9d9",
    borderRadius: "4px",
    padding: "1rem",
    height: "100%",
  },

  addSignerCard: {
    border: "1px solid #d9d9d9",
    borderRadius: "4px",
    padding: "1rem",
    height: "100%",
  },
  fullWidthButton: {
    width: "100%",
  },
  fieldHeadings: {
    textAlign: "left",
    letterSpacing: "0px",
    color: theme.palette.MDCColors.textColor,
    opacity: 1,
  },
}));

// Identity fields differ per Personenform: JP shows the company name, NP shows first/last name.
const QESIdentitySetupForm = ({
  isDetailDialog,
  personenform,
  firstName,
  lastName,
  companyName,
  email,
  emailError,
  hrab,
  hrabError,
  validationMessages,
  loading,
  onEmailChange,
  onHrabChange,
  onStartSigningProcess,
}) => {
  const classes = useStyles();
  const isLegalPerson = personenform === formConstants.companyPerson;

  return (
    <div className={classes.setupForm}>
      {loading && (
        <div className={classes.loaderOverlay}>
          <MDCLoader />
        </div>
      )}
      {isLegalPerson ? (
        <div>
          <MDCLabel
            className={classes.fieldHeadings}
            label={QES_SIGNING_START.COMPANY_NAME_LABEL}
            isReadOnly
          />
          <div className={classes.readonlyValue} title={companyName || "-"}>
            {companyName || "-"}
          </div>
        </div>
      ) : (
        <div className={classes.fieldRow}>
          <div>
            <MDCLabel
              className={classes.fieldHeadings}
              label="Vorname"
              isReadOnly
            />
            <div className={classes.readonlyValue} title={firstName || "-"}>
              {firstName || "-"}
            </div>
          </div>
          <div>
            <MDCLabel
              className={classes.fieldHeadings}
              label="Nachname"
              isReadOnly
            />
            <div className={classes.readonlyValue} title={lastName || "-"}>
              {lastName || "-"}
            </div>
          </div>
        </div>
      )}

      <Grid marginTop="1rem">
        {isLegalPerson ? (
          <>
            <MDCLabel className={classes.fieldHeadings} label="HRA/HRB" />
            <MDCText
              name="hrab"
              type="text"
              value={hrab}
              error={hrabError || validationMessages.hrab}
              onChange={onHrabChange}
              readOnly={isDetailDialog}
            />
            <ErrorText error={hrabError || validationMessages.hrab} />
          </>
        ) : (
          <>
            <MDCLabel
              className={classes.fieldHeadings}
              label="E-Mail-Adresse"
            />
            <MDCText
              name="email"
              type="email"
              value={email}
              error={emailError || validationMessages.email}
              onChange={onEmailChange}
              readOnly={isDetailDialog}
            />
            <ErrorText error={emailError || validationMessages.email} />
          </>
        )}
        <ErrorText error={validationMessages.firstName} />
        <ErrorText error={validationMessages.lastName} />
      </Grid>
      <div className={classes.actions}>
        <MDCButton
          variant="contained"
          label={
            isLegalPerson
              ? QES_SIGNING_START.START_VERIFICATION
              : "Signaturprozess starten"
          }
          disabled={
            isDetailDialog || (isLegalPerson ? !hrab : !email) || loading
          }
          onClick={onStartSigningProcess}
          className={classes.fullWidthButton}
        />
      </div>
    </div>
  );
};

export default QESIdentitySetupForm;
